import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { UserType, useUserType } from '@utils/hooks/useUserType';

import { SkeletonDashboardPage } from '@domains/dashboard/DashboardPage.skeleton';

export interface BasicRouteProps {
    children: ReactNode;
    condition: boolean;
    loading?: boolean;
    onRedirect?: () => void;
    redirectTo: string;
    users: UserType[];
}

export const BasicRoute = ({
    children,
    condition,
    loading,
    onRedirect,
    redirectTo,
    users,
}: BasicRouteProps) => {
    const userType = useUserType();

    const forCurrentUser = users?.includes(userType);
    const redirect = (!forCurrentUser && !loading) || (!condition && !loading);

    useEffect(() => {
        redirect && onRedirect?.();
    }, [redirect]);

    if (redirect) {
        return <Navigate to={redirectTo} />;
    }

    if (loading) return <SkeletonDashboardPage />;

    return <>{children}</>;
};
